import { useEffect } from 'react'
import { path } from 'ramda'

import { useDispatch, useSelector } from '@/lib/redux'

export type Flag<T> = {
  id: string
  key_name: string
  key_value: T
  system: string
}

type GetFlagProps<T> = Flag<T> | undefined

const useGetUserFlag = <T>(flagName: string): GetFlagProps<T> => {
  const dispatch = useDispatch()
  const flag = useSelector<GetFlagProps<T>>(path(['flags', flagName]))
  useEffect(() => {
    dispatch.flags.getUserFlag(flagName)
  }, [dispatch.flags, flagName])
  return flag
}

export default useGetUserFlag
